import type { UserRole } from "@/features/auth/useCurrentUser";

export type HomeVariant = UserRole;

export function resolveHomeVariant(role?: UserRole | null): HomeVariant {
  switch (role) {
    case "supplier":
      return "supplier";
    case "client":
      return "client";
    case "checker":
      return "checker";
    case "overviewer":
      return "overviewer";
    case "super":
    default:
      return "super";
  }
}

export function resolvePostLoginRedirect(
  redirect?: string,
  _role?: UserRole | null,
): string {
  if (redirect) {
    return redirect;
  }

  return "/";
}
